import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ORMMediator } from 'utility-ts-datasource';
import { IAppointmentLocationsOrganizersDatasource } from '../datasources/appointment_location_staff_datasource';
import { IAppointmentType, IStudentService } from '../types/appointment_interfaces';
import { ILocation, ILocationCourses, IOrganizer } from '../types/appt_interfaces';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

interface IAppointmentsCoursesResult {
  coursesList: ILocationCourses[];
  coursesInstructions: string;
  hasCourses: boolean;
  errorMessage: string;
  showCourses: boolean;
}

export class AppointmentsCoursesQuery implements IQuery {
  private _result: IAppointmentsCoursesResult;
  constructor(
    private ngAppointmentLocationsOrganizersDatasource: IAppointmentLocationsOrganizersDatasource,
    private ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
    private ngAppointmentReasonUsersource: TAppointmentReasonUsersource
  ) {
    ORMMediator.registerQuery(
      this,
      ngAppointmentLocationsOrganizersDatasource,
      ngAppointmentLocationsOrganizersUsersource
    );
  }

  run(): this {
    const selectedType = this.ngAppointmentReasonUsersource.read().selectedType;
    if (!!selectedType.instructions) {
      const coursesInstructions = selectedType.instructions.course;
      const errorMessage = selectedType.instructions.organizers_error;
      const selectedLocation = this.ngAppointmentLocationsOrganizersUsersource.read().selectedLocation;
      const showCourses = _4.gt(selectedLocation.id, 0) && selectedLocation.include_courses;
      let coursesList: ILocationCourses[] = [];
      let hasCourses = false;
      if (showCourses) {
        coursesList = selectedLocation.courses || [];
        hasCourses = coursesList.length > 0;
        coursesList = _4.map(coursesList, (course) => {
          return {
            ...course,
            name: _4.get(course, 'section_display_name', course.name)
          };
        });
      }
      this._result = {
        coursesList,
        coursesInstructions,
        errorMessage,
        hasCourses,
        showCourses
      };
    }
    return this;
  }

  get result(): IAppointmentsCoursesResult {
    return this._result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/queries/appointments_courses_query.ts